import styled from 'styled-components';
import { color, space, font, query } from '@design/templateFns';

//
//
// Listing Details
//
export const ListingSnapshotWrapper = styled.div<{ $grayOut: boolean }>`
  display: flex;
  flex-wrap: wrap;
  margin: ${space('md')} 0;
  opacity: ${({ $grayOut }) => ($grayOut ? '0.25' : '1')};

  @media screen and (${query.below('tablet')}) {
    margin: ${space('xl')} 0;
  }
`;

export const ListingSnapshotItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${space('md')};
  padding-right: ${space('x7')};
  margin-bottom: ${space('sm')};

  &:nth-child(1) {
    order: 1;
  } // Reorder list items to match columns
  &:nth-child(2) {
    order: 2;
  }
  &:nth-child(3) {
    order: 3;
  }
  &:nth-child(4) {
    order: 4;
  }
  &:nth-child(5) {
    order: 5;
  }
  &:nth-child(6) {
    order: 6;
  }
  &:nth-child(7) {
    order: 7;
  }

  @media screen and (${query.below('tablet')}) {
    flex: 0 0 50%;
    box-sizing: border-box;
    &:nth-child(1) {
      order: 2;
    } // Reorder list items to match columns
    &:nth-child(2) {
      order: 4;
    }
    &:nth-child(3) {
      order: 6;
    }
    &:nth-child(4) {
      order: 3;
    }
    &:nth-child(5) {
      order: 5;
    }
    margin-bottom: ${space('lg')};
    padding-right: ${space('lg')};
  }
`;

export const ListingSnapshotpan = styled.span``;

export const ListingProvider = styled.div<{ $grayOut: boolean }>`
  order: 1;
  flex: 0 0 100%;
  ${font('body-sm-light')};
  color: ${color('gray4')};
  opacity: ${({ $grayOut }) => ($grayOut ? '0.15' : '1')};

  a {
    color: ${color('gray4')};
    text-decoration: none;

    &:visited {
      color: ${color('gray4')};
    }

    &:hover {
      color: ${color('gray5')};
      text-decoration: underline;
    }
  }
`;
